/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Free_UnlimitedInputs */



/**
* | output |
* | --- |
* | "Unlimited spaces & projects" |
*
* @param {Plan_Feature_Free_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_unlimited = /** @type {((inputs?: Plan_Feature_Free_UnlimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_UnlimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzte Spaces & Projekte")
	return /** @type {LocalizedString} */ ("Unlimited spaces & projects")
});